import { createContainer, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const matchSummaryContainer = createContainer();

export const matchesSummary = style({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  gap: vars.space.xs,
  containerName: matchSummaryContainer,
  containerType: "inline-size",
});
